import './styles.scss';

interface Props {
    animate: boolean;
}

export default function ProgressBar(props: Props): JSX.Element {

    return (
        <div className='progress-bar'>
            <div className={`progress${props.animate ? ' animate' : ''}`}></div>
        </div>
    );

}
